import { defineMessages } from 'react-intl';

export const i18n: {
	confluenceFilterLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	content: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	content: {
		id: 'dynamic-cards-search-page.filters.names.content',
		defaultMessage: 'Content under',
		description: 'Label for filtering by content under a confluence page',
	},
	confluenceFilterPlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.content.placeholder',
		defaultMessage: 'Find content',
		description: 'Placeholder for content filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.content.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter content selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'dynamic-cards-search-page.confluence.filter.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter content unselected',
	},
});
